var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('icon-full-screen',{staticClass:"controls-full-screen",class:[_vm.is_disabled],on:{"click":_vm.emitClick}})}
var staticRenderFns = []

export { render, staticRenderFns }